import ContainerDimensions from './container'

export default ContainerDimensions
